import React from "react";

const services = [
  "Plumber","Electrician","Carpenter","AC Repair","Cleaning",
  "Salon","Spa","Massage","Painter","Pest Control",
  "Car Wash","Bike Repair","Laptop Repair","Mobile Repair",
  "Photographer","Event Planner","Cook","Driver",
  "Home Tutor","Fitness Trainer","Yoga Trainer",
  "Taxi","Delivery","Courier",
  "Interior Design","Architect","Security Guard",
  "Babysitter","Pet Care","Tailor","Mehndi Artist"
];

function App() {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black min-h-screen text-white">

      {/* 🔥 NAVBAR */}
      <nav className="sticky top-0 z-50 backdrop-blur-md bg-white/5 border-b border-white/10 px-10 py-5 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white">Fixado</h1>
        <button className="bg-white text-black px-5 py-2 rounded-full">
          Login
        </button>
      </nav>

      {/* 🔥 HERO */}
      <div className="text-center mt-16 px-6">
        <h2 className="text-5xl font-bold">
          All Services in One Place 🌍
        </h2>
        <p className="mt-4 text-gray-400">
          Book anything, anytime, anywhere
        </p>

        <div className="mt-8 max-w-2xl mx-auto flex gap-3 bg-white/10 p-3 rounded-xl">
          <input
            placeholder="Search any service..."
            className="flex-1 bg-transparent outline-none px-3 text-white"
          />
          <button className="bg-blue-500 px-6 rounded-xl">
            Search
          </button>
        </div>
      </div>

      {/* 🔥 SERVICES GRID */}
      <div className="mt-20 px-10">
        <h3 className="text-3xl font-bold text-center mb-10">
          Explore All Services
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">

          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl border border-white/10 hover:scale-105 transition cursor-pointer"
            >
              <h4 className="text-lg font-semibold">{service}</h4>
            </div>
          ))}

        </div>
      </div>

      {/* 🔥 FEATURE SECTION */}
      <div className="mt-24 px-10 text-center">
        <h3 className="text-3xl font-bold mb-6">
          Why Choose Fixado?
        </h3>

        <div className="grid md:grid-cols-3 gap-6">

          <div className="bg-white/10 p-6 rounded-xl">
            ⚡ Fast Booking <br /> Book services instantly
          </div>

          <div className="bg-white/10 p-6 rounded-xl">
            🔒 Trusted Professionals <br /> Verified experts only
          </div>

          <div className="bg-white/10 p-6 rounded-xl">
            💎 Premium Experience <br /> Luxury feel services
          </div>

        </div>
      </div>

      {/* 🔥 FOOTER */}
      <div className="mt-24 py-10 text-center text-gray-400 border-t border-white/10">
        © 2026 Fixado. All services worldwide 🌍
      </div>

    </div>
  );
}

export default App;